import { render, staticRenderFns } from "./estilo-vida-evidencia.vue?vue&type=template&id=66fc409e&scoped=true&"
import script from "./estilo-vida-evidencia.vue?vue&type=script&lang=js&"
export * from "./estilo-vida-evidencia.vue?vue&type=script&lang=js&"
import style0 from "./estilo-vida-evidencia.vue?vue&type=style&index=0&id=66fc409e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fc409e",
  null
  
)

export default component.exports